import React from 'react';
import { useLocation } from 'react-router-dom';

function withLocation(Component: any) {
  return (props: any) => <Component {...props} location={useLocation()} />;
}

export default withLocation;
